// This file is auto-generated by the `update-kc-gen` command. Do not edit it manually.
// Hash: 1e96d7dc37841aa50c450c1901d1f2596fcc8071591730e7473047f1fa2bcb36

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

import { lazy, Suspense, type ReactNode } from "react";

export type ThemeName = "diel-energia";

export const themeNames: ThemeName[] = ["diel-energia"];

export type KcEnvName = never;

export const kcEnvNames: KcEnvName[] = [];

export const kcEnvDefaults: Record<KcEnvName, string> = {};

/**
 * NOTE: Do not import this type except maybe in your entrypoint.
 * If you need to import the KcContext import it either from src/login/KcContext.ts or src/account/KcContext.ts.
 * Depending on the theme type you are working on.
 */
export type KcContext = import("./login/KcContext").KcContext;

declare global {
  interface Window {
    kcContext?: KcContext;
  }
}

export const KcLoginPage = lazy(() => import("./login/KcPage"));

export function KcPage(props: { kcContext: KcContext; fallback?: ReactNode }) {
  const { kcContext, fallback } = props;
  return (
    <Suspense fallback={fallback}>
      {(() => {
        switch (kcContext.themeType) {
          case "login":
            return <KcLoginPage kcContext={kcContext} />;
        }
      })()}
    </Suspense>
  );
}
